var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hightlights-list-item',{attrs:{"title":"Wind status","value":_vm.value,"value-measure":" m/s"}},[_c('div',{staticClass:"wind-footer"},[_c('span',{staticClass:"wind-footer__icon wind-footer__icon--size material-icons",style:(_vm.rotate)},[_vm._v(" navigation ")]),_vm._v(" "+_vm._s(_vm.windDirection)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }